export const extractCdns = (cdns) => {
  if (!cdns || !Array.isArray(cdns)) {
    return [];
  }
  return cdns.map((cdn) => cdn.urlOrTag);
};

const saveAIgeneratedCssCdns = async (
  cdns,
  projectId,
  version,
  customComponentId,
  addCustomComponentCssCdn,
  customCssCdns,
) => {
  if (!cdns || !Array.isArray(cdns) || cdns.length === 0) return;
  try {
    const existingUrls = customCssCdns.map((item) => item.urlOrTag);
    for (const cdn of cdns) {
      if (cdn.urlOrTag && !existingUrls.includes(cdn.urlOrTag)) {
        const cdnData = {
          projectId,
          version,
          componentId: customComponentId,
          urlOrTag: cdn.urlOrTag,
        };
        try {
          await addCustomComponentCssCdn(cdnData);
        } catch (error) {
          console.log(error);
        }
      }
    }
  } catch (error) {
    console.error('Error saving filtered CSS CDNs:', error);
  }
};

const saveAIgeneratedJsCdns = async (
  cdns,
  projectId,
  version,
  customComponentId,
  addCustomComponentJsCdn,
  customJsCdns,
) => {
  if (!cdns || !Array.isArray(cdns) || cdns.length === 0) {
    console.log('No JS CDNs to save');
    return;
  }

  try {
    const existingUrls = customJsCdns.map((item) => item.urlOrTag);
    for (const cdn of cdns) {
      if (cdn.urlOrTag && !existingUrls.includes(cdn.urlOrTag)) {
        const cdnData = {
          projectId,
          version,
          componentId: customComponentId,
          urlOrTag: cdn.urlOrTag,
        };

        try {
          const res = await addCustomComponentJsCdn(cdnData);
        } catch (error) {
          console.error('Error saving a JS CDN:', error);
        }
      }
    }
  } catch (error) {
    console.error('Error filtering and saving JS CDNs:', error);
  }
};

const parseAIResponse = async (aiCdns) => {
  if (!Array.isArray(aiCdns)) return [];
  try {
    const parsedList = aiCdns.map((item) => (typeof item === 'string' ? JSON.parse(item) : item));
    return parsedList;
  } catch (error) {
    console.error('Error parsing AI response CDNs:', error);
    return [];
  }
};

export const handleGenerateComponent = async (
  generateCustomComponent,
  args,
  setHtmlContent,
  setCustomCSS,
  setCustomJS,
  customComponentId,
  addCustomComponentCssCdn,
  addCustomComponentJsCdn,
  customCssCdns,
  customJsCdns,
) => {
  try {
    const { projectId, version } = args;
    const generatedContent = await generateCustomComponent(args);

    let aiCssCdns = [];
    let aiJsCdns = [];

    if (generatedContent && generatedContent.data) {
      const content = generatedContent.data.data;

      setHtmlContent(content.htmlContent || '');
      setCustomCSS(content.customCSS || '');
      setCustomJS(content.customJS || '');

      aiCssCdns = Array.isArray(content.customCssCdns) ? content.customCssCdns : [];
      aiJsCdns = Array.isArray(content.customJsCdns) ? content.customJsCdns : [];
    }

    const parsedCssCdnsList = await parseAIResponse(aiCssCdns);
    const parsedJsCdnsList = await parseAIResponse(aiJsCdns);

    await saveAIgeneratedCssCdns(
      parsedCssCdnsList,
      projectId,
      version,
      customComponentId,
      addCustomComponentCssCdn,
      customCssCdns,
    );

    await saveAIgeneratedJsCdns(
      parsedJsCdnsList,
      projectId,
      version,
      customComponentId,
      addCustomComponentJsCdn,
      customJsCdns,
    );
  } catch (error) {
    console.error('Error in generating component', error);
    throw error;
  }
};

export const tooltipDetails = (type) => {
  let description = '';
  switch (type) {
    case 'javascript':
      description = `
        <ul style="padding-left: 1rem">
            <li>
              <b>Avoid Reserved or Conflicting Variable and Function Names</b>
              Variable and Function names must not conflict with system-defined identifiers, library-specific variables, or commonly reserved terms (e.g., data, status, response).</li>
            <li>
              <b>Avoid Short and Single Character Variable And Function Names</b>
              Variable and Function names must not be less than 3 characters and avoid variable names like i, j, k, x, y, z etc</li>
            <li>
              <b>Timestamped Variable Declarations (Handled by Custom Component)</b>
              To ensure uniqueness in the DOM registry during component re-renders, variable declarations are automatically suffixed with a timestamp. This behavior is managed by the custom component implementation.</li>
            <li>
              <b>Use Dynamic Elements</b>
              Implement Dynamic Field, Dynamic Link, and Dynamic Event placeholders, which are replaced by their corresponding custom dynamic components during render.</li>
            <li>
              <b>Function and Variable name should contain number and underscore</b>
              Having Variable and function names with underscore and numbers is a good practice as they are less likely to conflict with system defined or library-specific names.</li>
        </ul>
        `;
      break;
    default:
      break;
  }
  return description;
};
